import { User, UserPermissions } from '@centecomm/portal-service';
import { LDClient } from 'launchdarkly-react-client-sdk';
import { UserTypeAgnosticSettings } from 'State/Settings/Types/UserTypeAgnosticSettings';

import { FeatureConfiguration } from '../Types/FeatureConfiguration';
import { FeatureRoute } from '../Types/FeatureRoute';
import { FeatureVisibilityContext } from '../Types/FeatureVisibilityContext';
import { NavigationItem } from '../Types/NavigationItem';
import { passesVisibilityRule } from './featureVisibility';

const filterFeatureAccess = (
    featureConfiguration: FeatureConfiguration[],
    checkPermission: (permission: UserPermissions) => boolean,
    currentUser: User,
    visibilityContext: FeatureVisibilityContext,
    settings?: UserTypeAgnosticSettings,
    ldClient?: LDClient,
): FeatureRoute[] =>
    featureConfiguration
        .filter(({ navigationItem, checkIfEnabledViaSettings, launchDarklyFlags, visibilityRule }: FeatureConfiguration) => {
            if (!navigationItem) return false;

            // Check LaunchDarkly flags if any are specified
            if (launchDarklyFlags && launchDarklyFlags.length > 0 && ldClient) {
                const allFlagsEnabled = launchDarklyFlags.every((flag) => ldClient.variation(flag, false) === true);

                if (!allFlagsEnabled) {
                    return false;
                }
            }

            if (!passesVisibilityRule(visibilityRule, visibilityContext)) {
                return false;
            }

            if (checkIfEnabledViaSettings && settings && !checkIfEnabledViaSettings(settings)) {
                return false;
            }

            const { permissions = [], isGloballyAccessible = false, isAllowed } = navigationItem;

            if (isGloballyAccessible) return true;

            if (permissions && permissions.length > 0) {
                return permissions.some((permission) => checkPermission(permission));
            }

            return !!isAllowed && isAllowed(currentUser);
        })
        .map(({ navigationItem }: FeatureConfiguration) => navigationItem)
        .map(({ route }: NavigationItem) => route);

export default filterFeatureAccess;
